(function () {
  'use strict';

  var STORAGE_KEY = 't4s_search_history';
  var MAX_ITEMS = 8;

  function readHistory() {
    try {
      var raw = localStorage.getItem(STORAGE_KEY);
      var list = raw ? JSON.parse(raw) : [];
      return Array.isArray(list) ? list : [];
    } catch (e) {
      return [];
    }
  }

  function writeHistory(list) {
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(list.slice(0, MAX_ITEMS)));
    } catch (e) { /* ignore */ }
  }

  function normalizeTerm(term) {
    return (term || '').trim().replace(/\s+/g, ' ');
  }

  function addHistory(term) {
    term = normalizeTerm(term);
    if (!term || term.length < 1) return;
    var list = readHistory().filter(function (t) {
      return t.toLowerCase() !== term.toLowerCase();
    });
    list.unshift(term);
    writeHistory(list);
  }

  function clearHistory() {
    try {
      localStorage.removeItem(STORAGE_KEY);
    } catch (e) { /* ignore */ }
  }

  function buildSearchHref(base, term) {
    return base + encodeURIComponent(term);
  }

  function renderBlock(wrap) {
    if (!wrap) return;
    var root = wrap.closest('[data-t4s-search-extras]');
    if (!root) return;
    var listEl = wrap.querySelector('[data-t4s-search-history-list]');
    if (!listEl) return;
    var base = root.getAttribute('data-search-q-base') || '/search?q=';
    var items = readHistory();
    listEl.innerHTML = '';
    if (!items.length) {
      wrap.classList.add('t4s-dn');
      return;
    }
    wrap.classList.remove('t4s-dn');
    items.forEach(function (term) {
      var li = document.createElement('li');
      li.className = 't4s-d-inline-block';
      var a = document.createElement('a');
      a.setAttribute('data-key', term);
      a.setAttribute('href', buildSearchHref(base, term));
      a.textContent = term;
      li.appendChild(a);
      listEl.appendChild(li);
    });
  }

  function renderAll() {
    document.querySelectorAll('[data-t4s-search-history-wrap]').forEach(renderBlock);
  }

  function getInputTerm(form) {
    if (!form) return '';
    var input = form.querySelector('[data-input-search]');
    return input ? input.value : '';
  }

  function bindExtras(root) {
    if (!root || root.getAttribute('data-t4s-search-bound')) return;
    root.setAttribute('data-t4s-search-bound', '1');

    var clearBtn = root.querySelector('[data-t4s-search-history-clear]');
    if (clearBtn) {
      clearBtn.addEventListener('click', function (e) {
        e.preventDefault();
        clearHistory();
        renderAll();
      });
    }

    root.addEventListener('click', function (e) {
      var link = e.target.closest('[data-t4s-search-history-list] a[data-key], .t4s-search-extras__hot a[data-key]');
      if (!link) return;
      var term = link.getAttribute('data-key') || link.textContent;
      addHistory(term);
      setTimeout(renderAll, 0);
    });
  }

  function bindForm(form) {
    if (!form || form.getAttribute('data-t4s-search-form-bound')) return;
    form.setAttribute('data-t4s-search-form-bound', '1');

    form.addEventListener('submit', function () {
      addHistory(getInputTerm(form));
      setTimeout(renderAll, 0);
    });

    var input = form.querySelector('[data-input-search]');
    if (input) {
      input.addEventListener('focus', renderAll);
    }
  }

  function syncSearchDrawerPanel() {
    var drawer = document.getElementById('t4s-search-hidden');
    if (!drawer) return;
    var form = drawer.querySelector('[data-frm-search]');
    var content = drawer.querySelector('.t4s-drawer__content');
    var title = drawer.querySelector('[data-title-search]');
    var input = form ? form.querySelector('[data-input-search]') : null;
    var hasTerms = !!(form && (form.classList.contains('has--search-terms') || (input && input.value.trim())));

    if (content) {
      content.classList.toggle('is--awaiting-query', !hasTerms);
    }
    if (title && !hasTerms) {
      title.style.display = 'none';
    }
  }

  function toggleSearchClearBtn(input, clearBtn) {
    if (!input || !clearBtn) return;
    var hasValue = !!input.value.trim();
    clearBtn.hidden = !hasValue;
  }

  function bindSearchInputClear(form) {
    if (!form || form.getAttribute('data-t4s-search-clear-bound')) return;
    form.setAttribute('data-t4s-search-clear-bound', '1');
    var input = form.querySelector('[data-input-search], .t4s-search-results-bar__input');
    var clearBtn = form.querySelector('[data-search-input-clear], [data-clear-search]');
    if (!input || !clearBtn) return;
    input.addEventListener('input', function () {
      toggleSearchClearBtn(input, clearBtn);
    });
    toggleSearchClearBtn(input, clearBtn);
  }

  function bindSearchDrawerInput(form) {
    if (!form || form.getAttribute('data-t4s-search-panel-input-bound')) return;
    form.setAttribute('data-t4s-search-panel-input-bound', '1');
    var input = form.querySelector('[data-input-search]');
    if (input) {
      input.addEventListener('input', syncSearchDrawerPanel);
    }
  }

  function observeSearchDrawerPanel() {
    var drawer = document.getElementById('t4s-search-hidden');
    if (!drawer) return;

    var form = drawer.querySelector('[data-frm-search]');
    if (form && !form.getAttribute('data-t4s-search-panel-observed')) {
      form.setAttribute('data-t4s-search-panel-observed', '1');
      var formObserver = new MutationObserver(syncSearchDrawerPanel);
      formObserver.observe(form, { attributes: true, attributeFilter: ['class'] });
      bindSearchDrawerInput(form);
    }

    syncSearchDrawerPanel();
  }

  function init() {
    document.querySelectorAll('[data-t4s-search-extras]').forEach(function (root) {
      bindExtras(root);
      var form = root.closest('[data-frm-search]') || root.parentElement && root.parentElement.querySelector('[data-frm-search]');
      if (!form) {
        var container = root.closest('[data-predictive-search]') || root.closest('.t4s-search-header__form-wrap');
        if (container) form = container.querySelector('[data-frm-search]');
      }
      if (form) {
        bindForm(form);
        bindSearchInputClear(form);
      }
      var wrap = root.querySelector('[data-t4s-search-history-wrap]');
      if (wrap) renderBlock(wrap);
    });

    document.querySelectorAll('[data-frm-search], .t4s-search-results-bar__frm').forEach(function (form) {
      bindForm(form);
      bindSearchInputClear(form);
    });

    observeSearchDrawerPanel();
  }

  document.addEventListener('DOMContentLoaded', init);

  document.addEventListener('click', function (e) {
    var opener = e.target.closest('[data-drawer-options*="#t4s-search-hidden"], [data-drawer-options*="t4s-search-hidden"]');
    if (opener) setTimeout(renderAll, 400);
  });

  var drawer = document.getElementById('t4s-search-hidden');
  if (drawer && typeof MutationObserver !== 'undefined') {
    var mo = new MutationObserver(function () {
      observeSearchDrawerPanel();
      if (drawer.getAttribute('aria-hidden') === 'false') {
        init();
        renderAll();
        syncSearchDrawerPanel();
      }
    });
    mo.observe(drawer, { attributes: true, attributeFilter: ['aria-hidden', 'class'], childList: true });
  }

  document.addEventListener('shopify:section:load', function () {
    init();
    renderAll();
  });

  document.addEventListener('click', function (e) {
    var clearBtn = e.target.closest('[data-search-input-clear], [data-clear-search]');
    if (!clearBtn) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    var form = clearBtn.closest('form');
    if (!form) return;
    var input = form.querySelector('[data-input-search], .t4s-search-results-bar__input, [name="q"]');
    if (!input) return;
    input.value = '';
    input.dispatchEvent(new Event('input', { bubbles: true }));
    input.focus();
    toggleSearchClearBtn(input, clearBtn);
  });
})();
